import cx from "classnames";
import type { FC } from "react";
import { Accordion } from "@/appInterface/windows/accordion";
import { useAccordion } from "@/appInterface/windows/shapeToolSubMenu/useAccordion";
import { ShapeGrid } from "./ShapeGrid";
import style from "./shapeToolSubMenu.module.css";

type ShapeToolSubMenuLayoutProps = {
    selectedMode: string | null;
    onModeChange: (mode: string) => void;
    basicShapes: string[];
    diagramShapes: string[];
    bpmnShapes: string[];
    umlShapes: string[];
};

export const ShapeToolSubMenuLayout: FC<ShapeToolSubMenuLayoutProps> = ({
    selectedMode,
    onModeChange,
    basicShapes,
    diagramShapes,
    bpmnShapes,
    umlShapes,
}) => {
    const { accordionState, updateSection } = useAccordion();

    return (
        <div className={style.shapeToolSubMenu}>
            <div className={style.shapeToolSubMenuTitle}>
                <p className={style.title}>Фигуры</p>
            </div>
            <div className={cx(style.content, "scrollable")}>
                <Accordion
                    title="Базовые"
                    section="basic"
                    defaultExpanded={accordionState.basic}
                    onUpdateSection={updateSection}
                >
                    <ShapeGrid
                        shapes={basicShapes}
                        selectedMode={selectedMode}
                        onModeChange={onModeChange}
                    />
                </Accordion>
                <Accordion
                    title="Диаграммы"
                    section="diagrams"
                    defaultExpanded={accordionState.diagrams}
                    onUpdateSection={updateSection}
                >
                    <ShapeGrid
                        shapes={diagramShapes}
                        selectedMode={selectedMode}
                        onModeChange={onModeChange}
                    />
                </Accordion>
                <Accordion
                    title="BPMN"
                    section="bpmn"
                    defaultExpanded={accordionState.bpmn}
                    onUpdateSection={updateSection}
                >
                    <ShapeGrid
                        shapes={bpmnShapes}
                        selectedMode={selectedMode}
                        onModeChange={onModeChange}
                    />
                </Accordion>
                <Accordion
                    title="UML"
                    section="uml"
                    defaultExpanded={accordionState.uml}
                    onUpdateSection={updateSection}
                >
                    <ShapeGrid
                        shapes={umlShapes}
                        selectedMode={selectedMode}
                        onModeChange={onModeChange}
                    />
                </Accordion>
            </div>
        </div>
    );
};
